module.exports = __webpack_public_path__ + "img/pangao_logo.6dd53052.png";